import React from "react";
import {
  FaHeartbeat,
  FaGraduationCap,
  FaVenusMars,
  FaTint,
  FaSun,
  FaBriefcase,
  FaIndustry,
  FaBalanceScale,
  FaBuilding,
  FaRecycle,
  FaGlobeAmericas,
  FaFish,
  FaTree,
  FaHandshake,
  FaUtensils,
  FaHandsHelping,
  FaUsers
} from "react-icons/fa";

export const getSDGIcon = (number, color = "#3B82F6") => {
  const iconStyle = { fontSize: "42px", color: color };
  switch (Number(number)) {
    case 1:
      return <FaHandsHelping style={iconStyle} />;
    case 2:
      return <FaUtensils style={iconStyle} />;
    case 3:
      return <FaHeartbeat style={iconStyle} />;
    case 4:
      return <FaGraduationCap style={iconStyle} />;
    case 5:
      return <FaVenusMars style={iconStyle} />;
    case 6:
      return <FaTint style={iconStyle} />;
    case 7:
      return <FaSun style={iconStyle} />;
    case 8:
      return <FaBriefcase style={iconStyle} />;
    case 9:
      return <FaIndustry style={iconStyle} />;
    case 10:
      return <FaBalanceScale style={iconStyle} />;
    case 11:
      return <FaBuilding style={iconStyle} />;
    case 12:
      return <FaRecycle style={iconStyle} />;
    case 13:
      return <FaGlobeAmericas style={iconStyle} />;
    case 14:
      return <FaFish style={iconStyle} />;
    case 15:
      return <FaTree style={iconStyle} />;
    case 16:
      return <FaUsers style={iconStyle} />;
    case 17:
      return <FaHandshake style={iconStyle} />;
    default:
      return <FaGlobeAmericas style={iconStyle} />;
  }
};
